window.parallaxClose = false;
window.root = 0;
(function($) {
    window.scrollSpeed = function(step, speed, easing) {
        if (navigator.platform.toLowerCase() == "macintel") {
            return;
        }
        var $document = $(document),
            $window = $(window),
            $body = $("html, body"),
            option = easing || "default",
            scroll = false,
            scrollY,
            scrollX,
            view;

        if (window.navigator.msPointerEnabled) return false;

        $(".bodyTemplate,.bodyTemplates")
            .on("mousewheel DOMMouseScroll", function(e) {
                console.log("parallaxClose=" + parallaxClose);
                if (parallaxClose) {
                    console.log("return false;asdfklj;");
                    return false;
                }
                console.log($(e.target).get(0).tagName);

                var deltaY = e.originalEvent.wheelDeltaY,
                    detail = e.originalEvent.detail;
                scrollY = $document.height() > window.innerHeight;
                console.log($document.height() + "+" + window.innerHeight);
                scrollX = $document.width() > window.innerWidth;
                scroll = true;
                console.log("scrollY" + scrollY);
                if (scrollY) {
                    view = window.innerHeight;

                    if (deltaY < 0 || detail > 0)
                        root =
                            root + view >= $document.height()
                                ? root
                                : (root += step);

                    if (deltaY > 0 || detail < 0)
                        root = root <= 0 ? 0 : (root -= step);
                    console.log(root);
                    isElementScroll =
                        $(e.target).get(0).scrollHeight >
                        $(e.target).get(0).clientHeight;
                    console.log("isElementScroll" + isElementScroll);
                    if (isElementScroll) {
                        return true;
                    }
                    $body.stop().animate(
                        {
                            scrollTop: root
                        },
                        speed,
                        option,
                        function() {
                            scroll = false;
                        }
                    );
                }

                if (scrollX) {
                    // disable scroll x
                    return;
                    view = $window.width();

                    if (deltaY < 0 || detail > 0)
                        root =
                            root + view >= $document.width()
                                ? root
                                : (root += step);

                    if (deltaY > 0 || detail < 0)
                        root = root <= 0 ? 0 : (root -= step);
                }

                return false;
            })
            .on("scroll", function() {
                if (scrollY && !scroll) root = $window.scrollTop();
                if (scrollX && !scroll) root = $window.scrollLeft();
            })
            .on("resize", function() {
                if (scrollY && !scroll) view = $window.height();
                if (scrollX && !scroll) view = $window.width();
            });
    };

    jQuery.easing.default = function(x, t, b, c, d) {
        return -c * ((t = t / d - 1) * t * t * t - 1) + b;
    };
})(jQuery);
